import { createTheme } from "@mui/material/styles";

export const createAppTheme = (mode: "light" | "dark") =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: "#2f6f5f",
        dark: "#1e4f45",
        light: "#5ba895",
      },
      secondary: {
        main: "#f4b53f",
        dark: "#c9891b",
        light: "#ffd789",
      },
      background: {
        default: mode === "dark" ? "#0b1514" : "#f4efe6",
        paper: mode === "dark" ? "#121f1d" : "#fffaf3",
      },
      text: {
        primary: mode === "dark" ? "#e6f0ee" : "#1d2b2a",
        secondary: mode === "dark" ? "#9fb0ad" : "#4b5b5a",
      },
    },
    typography: {
      fontFamily: '"Space Grotesk", "Manrope", sans-serif',
      h1: {
        fontFamily: '"Fraunces", "Space Grotesk", serif',
        fontWeight: 600,
        fontSize: "clamp(2.4rem, 3vw, 3.4rem)",
      },
      h2: {
        fontFamily: '"Fraunces", "Space Grotesk", serif',
        fontWeight: 600,
        fontSize: "clamp(1.8rem, 2.4vw, 2.6rem)",
      },
      h3: {
        fontWeight: 600,
        fontSize: "1.35rem",
      },
      body1: {
        fontSize: "1rem",
      },
      body2: {
        fontSize: "0.95rem",
      },
    },
    shape: {
      borderRadius: 18,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 999,
            paddingInline: 20,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },
    },
  });
